import createReducer from 'reducers/createReducer';

import { Code } from 'actions/actionTypes';

const INITIAL_STATE = { 
    codeGroup: '',
    codeList: {
        
    },
    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Code.LOAD_CODE_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.codeGroup = action.payload;
    },
    [Code.LOAD_CODE_LIST_SUCCESS]: (state, action) => {
        state.codeList[action.payload.codeGroup]=action.payload.list;
    },
    [Code.LOAD_CODE_LIST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload.errorMessage
        };
    },
});


export default reducer;